
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"3","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#EBEBEB","fill-rule":"evenodd"}},[_c('ellipse',{attrs:{"cx":"1.519","cy":"13.5","rx":"1.501","ry":"1.5"}}),_c('ellipse',{attrs:{"cx":"1.519","cy":"7.5","rx":"1.501","ry":"1.5"}}),_c('ellipse',{attrs:{"cx":"1.519","cy":"1.5","rx":"1.501","ry":"1.5"}})])])
          )
        }
      }
    